import DemandeAddComponent from "../../components/Demandes/DemandeAddComponent";

function DemandeAdd() {

  return (
    <DemandeAddComponent  />
  );
}
export default DemandeAdd;